import _regeneratorRuntime from "/home/runner/work/ami/ami/jaenjs/templates/jaen-template-shopify/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

export function importFresh(modulePath) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var cacheBustingModulePath;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cacheBustingModulePath = "".concat(modulePath, "?update=").concat(Date.now());
            _context.next = 3;
            return import(cacheBustingModulePath);

          case 3:
            return _context.abrupt("return", _context.sent.default);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
export function stringify(obj_from_json) {
  if (typeof obj_from_json !== "object" || Array.isArray(obj_from_json)) {
    return JSON.stringify(obj_from_json);
  }

  var props = Object.keys(obj_from_json).map(function (key) {
    return "".concat(key, ":").concat(stringify(obj_from_json[key]));
  }).join(",");
  return "{".concat(props, "}");
}